// test2918
(2918 && 0);
